(function () {
	'use strict';

	angular
		.module('core.services')
		.service('CompanyEconomicGroupService', CompanyEconomicGroupService)

	/** @ngInject */
	function CompanyEconomicGroupService(HttpService) {
		const CompanyEconomicGroupService = {
			get,
			getAll,
			getByParameters,
			post,
			put,
			deleteData
		}

		return CompanyEconomicGroupService;

		function get(companyEconomicGroupId) {
			return HttpService.get(`/economic-group/${companyEconomicGroupId}`);
		}

		function getAll() {
			return HttpService.get('/economic-group/by-parameters', {
				params: {}
			});
		}

		function getByParameters(params) {
			return HttpService.get('/economic-group/by-parameters', {
				params
			});
		}

		function post(companyEconomicGroupData) {
			return HttpService.post('/economic-group', companyEconomicGroupData);
		}

		function put(companyEconomicGroupData) {
			return HttpService.put('/economic-group', companyEconomicGroupData);
		}

		function deleteData(companyEconomicGroupId) {
			return HttpService.delete(`/economic-group/${companyEconomicGroupId}`);
		}
	}
}());